import React, { useState, useEffect } from "react";
import axiosInstance from "../../api/axiosInstance";
import InstancesTable from "../../components/admin/InstancesTable";

const InstancesPage = () => {
    const [instances, setInstances] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchInstances = async () => {
            try {
                const clusterId = JSON.parse(
                    localStorage.getItem("selected_cluster")
                ).id;
                const res = await axiosInstance.get(`/admin/os/instances/cluster/${clusterId}`);
                setInstances(res.data || []);
            } catch (err) {
                console.error("Failed to fetch instances:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchInstances();
    }, []);

    return (
        <div className="min-h-screen text-white">
            <main className="container mx-auto px-4 py-6">
                {loading ? (
                    <div className="text-center text-gray-400 text-lg">
                        Loading instances...
                    </div>
                ) : (
                    <InstancesTable instances={instances} />
                )}
            </main>
        </div>
    );
};

export default InstancesPage;
